import { OrderExtraStatusAttributes } from '@albatrosdeveloper/ave-models-package';

interface DocumentWithTransactions {
  sourceTransactions?: Array<{ serial: string }>;
  sourceTransaction?: { serial: string };
  nextTransactions?: Array<{ serial: string }>;
  nextTransaction?: { serial: string };
}

export const formatDate = (date: string | Date, includeTime?: boolean): string => {
  if (date) {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();

    if (includeTime) {
      const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const seconds = d.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }
    return `${day}-${month}-${year}`;
  }
  return '--:--:--';
};

export const formatHour = (date: string): string => {
  if (date) {
    const d = new Date(date);
    const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const seconds = d.getSeconds().toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
  }
  return '--:--:--';
};

export const getExtraStatusName = (list: OrderExtraStatusAttributes[], type: string) => {
  const status = list.find((i) => i.type ==  type);
  return status?.description || '-';
};

export const getSourceDocument = (item: DocumentWithTransactions): string => {
  return item?.sourceTransactions?.[0]?.serial || 
         item?.sourceTransaction?.serial || '-';
};

export const getNextDocument = (item: DocumentWithTransactions): string => {
  return item?.nextTransactions?.[0]?.serial || 
         item?.nextTransaction?.serial || '-';
};
